import React, { memo } from 'react';
import { useInView } from 'react-intersection-observer';
import { reactHtmlParser, specialityPopOver } from '../../../common/common';
import VideoContainer from '../../commonClinicalVideo/VideoContainer';
import useRedirect from '../../customHooks/useRedirect';
import ShareCard from '../../ShareCard';
import './css/_clinicalVideoCardV2.scss';

function ClinicalVideoCardV2({
  id,
  url,
  title,
  specialities,
  specialities_ids_and_names,
  image,
  data,
  gtmTagVariable = ''
}) {
  const { redirectTo } = useRedirect();
  const click = () => redirectTo('ClinicalVideoDetails', id, title);
  const [clVideoref, inView] = useInView({
    fallbackInView: false,
    threshold: 0
  });
  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { id, name } = specialities_ids_and_names[0];
      redirectTo('Speciality', id, name);
    }
  };
  return (
    <div
      className="w-100 clinicalVideoCardV2Box bg-white shadow rounded-3 position-relative overflow-hidden"
      ref={clVideoref}
    >
      {/* <LazyImage
        src={image}
        alt="Medwiki img"
        className="object-fit-cover w-100 h-100 float-start position-absolute top-0 start-0"
        extraClass="w-100 h-100 position-relative overflow-hidden clinicalVideoPic"
        fallback_image={CLINICAL_DEMO}
        click={click}
      /> */}
      <VideoContainer
        _cl={data}
        inView={inView}
        isSearchCard
        gtmTagVariable={`${gtmTagVariable}_clinicalVideoCardV2`}
      />
      <div className="overlay" onClick={click}></div>
      <div
        className="shareBtn position-absolute bg-white bg-opacity-75 d-flex justify-content-center align-items-center z-2 rounded-3"
        style={{ zIndex: 92 }}
      >
        <ShareCard
          customClass={`fs-2 text-black ${gtmTagVariable}_clinicalVideoCardV2_share`}
          data={{ title, url }}
        />
      </div>
      <div className="clinicalVideoDetails text-start position-absolute bottom-0 z-2 p-3 p-md-4">
        {/* <div className="videoIcon bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center mb-3">
          <BsPlay customClass={'fs-1 text-white'} />
        </div> */}
        {specialities && (
          <h6 className="fs-4 fw-normal text-white speciality mb-1 d-flex align-items-center cursorPointer" style={{ zIndex: 95 }}>
            <span
              className={`${gtmTagVariable}_clinicalVideoCardV2_speciality`}
              onClick={specialityClick}
            >
              {/* {specialities?.split(',')[0]} */}
              {specialities_ids_and_names && specialities_ids_and_names.length > 0 && specialities_ids_and_names[0]?.name}
            </span>
            {specialityPopOver(specialities_ids_and_names && specialities_ids_and_names.length > 0 ? specialities_ids_and_names.map(speciality => speciality.name).join(",") : '')}
          </h6>
        )}
        <h4 className="fs-16 fw-medium text-white line-clamp-2">{reactHtmlParser(title)}</h4>
      </div>
    </div>
  );
}
export default memo(ClinicalVideoCardV2);
